import { useLanguage } from '../context/LanguageContext';
import { content } from '../data/mock';
import { variantA } from '../data/mock-variant-a';

const VARIANT_KEY = 'ab_variant';

// Reads ?variant=a from the URL once and persists it to localStorage.
// Clear localStorage key to return a visitor to the control.
function getVariant() {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get('variant');
  if (fromUrl) {
    localStorage.setItem(VARIANT_KEY, fromUrl);
    return fromUrl;
  }
  return localStorage.getItem(VARIANT_KEY);
}

const VARIANT_MAP = { a: variantA };

export const useContent = () => {
  const { lang } = useLanguage();
  const base = content[lang];
  const variant = getVariant();
  const overrides = VARIANT_MAP[variant]?.[lang];

  if (!overrides) return base;

  // Shallow-merge each overridden section; untouched sections use base as-is.
  return {
    ...base,
    hero: { ...base.hero, ...overrides.hero },
    reality: { ...base.reality, ...overrides.reality },
    problem: { ...base.problem, ...overrides.problem },
    cta: { ...base.cta, ...overrides.cta },
  };
};
